import React from "react";
import { Checkbox, TableCell, TableRow, Tooltip, withStyles, } from "@material-ui/core";
import { green } from '@material-ui/core/colors';
import { globalPostService } from "../../../globalServices";
import { checkApiStatus } from "../../utils_v2";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../utils/mixpanel";

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		'&$checked': {
			color: green[600],
		},
	},
	checked: {},
})((props) => <Checkbox color="default" {...props} />);

const CurrenciesList = ({ item, index, getCurrencies }) => {

	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const linkUnlink = (ids, type) => {
		let payload;
		if (type === 'link') {
			payload = {
				action: 'link',
				currency_ids: [ids?.id]
			};
		} else {
			payload = {
				action: 'unlink',
				currency_ids: [ids?.id]

			};
		}

		const apiUrl = `/console/global-currency/`;
		globalPostService(apiUrl, payload)
			.then((response) => {
				if (checkApiStatus(response)) {
					enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					getCurrencies();
					trackActivity('Console Management', { event_desc: type === 'link' ? `Shop Visit Event Linked Successfully` : 'Shop Visit Event unLinked Successfully', page_title: 'Aircraft Technical Specification', event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked', updated_id: ids, success_msg: response?.data?.message })
				} else {
					enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
					getCurrencies();
					trackActivity('Console Management', { event_desc: type === 'link' ? 'Shop Visit Event Linking Failed' : 'Shop Visit Event Unlinking Failed', page_title: 'Aircraft Technical Specification', event_type: type === 'link' ? 'Item Linked' : 'Item UnLinked', updated_id: ids, error_msg: response?.data?.message })
				}
			})
	}

	return (
		<>
			<TableRow key={index}>
				<TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.symbol || '--'}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.symbol_native || '--'}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.decimal_digits}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.rounding}</div></TableCell>
				<TableCell><div style={{ width: '150px' }}>{item?.code || '--'}</div></TableCell>
				<TableCell><div style={{ width: '50px' }}>
					<Tooltip title = {item?.enabled === true ? 'unlink' : 'link'} arrow>
						<span><GreenCheckbox color="success" size="small" checked={item?.enabled} onChange={(e) => { linkUnlink(item, item?.enabled === true ? 'unlink' : 'link') }} /></span>
					</Tooltip>
				</div></TableCell>
			</TableRow>
		</>
	)
}


export default CurrenciesList